import EvalCategories from "@/modules/evaluation/views/EvalCategories.vue";
import EvalCompetencies from "@/modules/evaluation/views/EvalCompetencies.vue";
import EvalCompetence from "@/modules/evaluation/views/EvalCompetence.vue";
import EvalScales from "@/modules/evaluation/views/EvalScales.vue";
import EvalProfiles from "@/modules/evaluation/views/EvalProfiles.vue";
import EvalProfile from "@/modules/evaluation/views/EvalProfile.vue";
import EvalEvaluations from "@/modules/evaluation/views/EvalEvaluations.vue";
import EvalEvaluation from "@/modules/evaluation/views/EvalEvaluation.vue";
import EvalMyEvaluations from "@/modules/evaluation/views/EvalMyEvaluations.vue";
import EvalMyEvaluation from "@/modules/evaluation/views/EvalMyEvaluation.vue";
import EvalRequests from "@/modules/evaluation/views/EvalRequests.vue";

export default [
    {
        path: '/evaluation/categories',
        name: 'EvalCategories',
        component: EvalCategories,
        meta: {title: 'Категории компетенций'}
    },
    {
        path: '/evaluation/competencies',
        name: 'EvalCompetencies',
        component: EvalCompetencies,
        meta: {title: 'Библиотека компетенций'}
    },
    {
        path: '/evaluation/competence/:id(\\d+)',
        name: 'EvalCompetence',
        component: EvalCompetence,
        meta: {title: 'Компетенция'}
    },
    {
        path: '/evaluation/profiles',
        name: 'EvalProfiles',
        component: EvalProfiles,
        meta: {title: 'Профили оценки'}
    },
    {
        path: '/evaluation/profile/:id(\\d+)',
        name: 'EvalProfile',
        component: EvalProfile,
        meta: {title: 'Профиль'}
    },
    {
        path: '/evaluation/scales',
        name: 'EvalScales',
        component: EvalScales,
        meta: {title: 'Шкалы оценки'}
    },
    {
        path: '/evaluation/evaluations',
        name: 'EvalEvaluations',
        component: EvalEvaluations,
        meta: {title: 'Каталог оценок 360'}
    },
    {
        path: '/evaluation/evaluation/:id(\\d+)',
        name: 'EvalEvaluation',
        component: EvalEvaluation,
        meta: {title: 'Оценка 360'}
    },
    {
        path: '/evaluation/my-evaluations',
        name: 'EvalMyEvaluations',
        component: EvalMyEvaluations,
        meta: {title: 'Мои оценки 360'}
    },
    {
        path: '/evaluation/my-evaluation/:id(\\d+)',
        name: 'EvalMyEvaluation',
        component: EvalMyEvaluation,
        meta: {title: 'Моя оценка 360'}
    },
    {
        path: '/evaluation/requests',
        name: 'EvalRequests',
        component: EvalRequests,
        meta: {title: 'Запросы подчиненных на оценку 360'}
    },
]
